import { mutationErrorCode } from '@src/lib/mutationErrors'

/** Clarity `LinkedAccount.app` (startups3 `CLARITY_LINKED_APP`). */
export const CLARITY_LINKED_APP = 'clarity'

export const CLARITY_SUPPORT_EMAIL = 'support@startups.com'

const ERROR_MESSAGES: Record<string, string> = {
  CLARITY_LINK_PROOF_REQUIRED: 'Enter the code we emailed to this Clarity account.',
  CLARITY_LINK_CODE_INVALID: 'That code is wrong or has expired. Send a new code and try again.',
  CLARITY_LINK_NEEDS_ADMIN: `We have no email for this Clarity account to verify. Contact ${CLARITY_SUPPORT_EMAIL} to link it.`,
  CLARITY_LINK_UNAVAILABLE: 'Clarity linking is not available right now. Try again later.',
  CLARITY_IMPORT_UNAVAILABLE: 'Clarity is not reachable right now. Try again later.',
  CLARITY_ACCOUNT_ALREADY_LINKED: `Your account is already linked to a different Clarity account. Contact ${CLARITY_SUPPORT_EMAIL} to change it.`,
  APP_ACCOUNT_ALREADY_CLAIMED: `This Clarity account is linked to another Startups.com account. Contact ${CLARITY_SUPPORT_EMAIL} if it's yours.`,
  LIMIT_EXCEEDED: 'Too many codes sent. Wait an hour, then try again.',
  NOT_FOUND: 'No Clarity expert found with that username.',
  USER_NOT_AUTHENTICATED: 'Sign in to link a Clarity account.',
}

/** Map a backend error key to copy; fall back for anything else. */
export const clarityLinkErrorMessage = (error: unknown, fallback: string): string => {
  const code = mutationErrorCode(error)
  const raw = (error instanceof Error ? error.message : typeof error === 'string' ? error : '') || ''
  const message = raw.replace(/^GraphQL error:\s*/i, '').trim()
  if (code && ERROR_MESSAGES[code]) {
    return ERROR_MESSAGES[code]
  }
  for (const [key, copy] of Object.entries(ERROR_MESSAGES)) {
    if (message === key || message.includes(key)) {
      return copy
    }
  }
  return fallback
}

/** `https://clarity.fm/ryan/`, `clarity.fm/ryan`, `@ryan` and `ryan` all become `ryan`. */
export const parseClarityHandleInput = (raw: string | null | undefined): string => {
  let value = String(raw || '').trim()
  value = value.replace(/^https?:\/\//i, '').replace(/^(www\.)?clarity\.fm\/?/i, '')
  value = value.split(/[?#]/)[0].replace(/^@/, '')
  return value.split('/').filter(Boolean)[0] || ''
}

/** Only digits, at most six. */
export const normalizeClarityCodeInput = (raw: string): string => raw.replace(/\D/g, '').slice(0, 6)
